import * as React from 'react';
import { Store } from 'redux';
import { Route } from 'react-router';
import { makeGetComponent } from './utils';
import { getSubscribeRoute } from './SubscribeRoute';

export const getNonAuthenticationRoute = (store: Store<RootState>) => (
  <Route>
    <Route path="login" getComponent={makeGetComponent('LoginPage')} />
    <Route
      path="forget"
      getComponent={makeGetComponent('ForgetPasswordPage')}
    />
    <Route
      path="signup"
      getComponent={makeGetComponent('SignUpPage/SignUpPageContainer')}
    />
    <Route
      path="data-interest-form"
      getComponent={makeGetComponent(
        'DataInterestFormPage/DataInterestFormPageContainer'
      )}
    />
    {/* Under development, please comment out when you merge to master branch */}
    <Route
      path="historical-price"
      getComponent={makeGetComponent('HistoricalPrice/Downloader')}
    />
    <Route
      path="historical-price/login"
      getComponent={makeGetComponent('HistoricalPrice/Login')}
    />
    {getSubscribeRoute()}
  </Route>
);



// WEBPACK FOOTER //
// ./app/routers/NonAuthenticationRoute.tsx